import React from 'react';
import Skills from '../components/Skills';

const SkillsPage: React.FC = () => {
  return (
    <div className="min-h-screen pt-16 md:pt-20">
      <Skills />
    </div>
  );
};

export default SkillsPage;
